import { userContext } from 'contexts/UserContext';
import { useContext, useEffect } from 'react';

declare global {
  interface Window {
    OmniWidgetApi: {
      call: (
        action:
          | 'hide_btn' // скрыть кнопку виджета;
          | 'show_btn' // показать кнопку виджета;
          | 'open' // раскрыть виджет;
          | 'close' // свернуть виджет;
          | 'open_widget' // открыть форму отправки email-запроса;
          | 'close_widget' // свернуть форму отправки email-запроса;
          | 'identify' // заполнить поля формы обратной связи по почте;
          | 'reset', // очистить поля формы обратной связи по почте.
        data?: unknown
      ) => void;
    };
  }
}

function safeOmniCall(
  action:
    | 'hide_btn'
    | 'show_btn'
    | 'open'
    | 'close'
    | 'open_widget'
    | 'close_widget'
    | 'identify'
    | 'reset',
  data?: unknown
) {
  try {
    window.OmniWidgetApi?.call(action, data);
  } catch (e) {
    console.error(e);
  }
}

setTimeout(() => {
  safeOmniCall('hide_btn');
}, 0);

export function useOmni() {
  const { user } = useContext(userContext);
  useEffect(() => {
    if (user) {
      safeOmniCall('show_btn');
      // window.OmniWidgetApi.call('identify', {
      //   user_email: user.Email,
      //   user_phone: user.Phone,
      //   company_name: user.Company
      // });
    } else {
      requestAnimationFrame(() => {
        safeOmniCall('hide_btn');
      });
    }
    return () => {
      // window.OmniWidgetApi.call('identify', {});
    };
  }, [user]);
}
